/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Options_ModalInputs */

const en_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close options modal`)
};

const fr_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre des options`)
};

const de_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen schließen Modal`)
};

const it_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la finestra delle opzioni`)
};

const ru_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно с параметрами`)
};

const es_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar opciones modal`)
};

const zh_cn2_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭选项模态框`)
};

const ja_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプションモーダルを閉じる`)
};

const hi_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विकल्प बंद करें`)
};

const pt_pt2_close_options_modal = /** @type {(inputs: Close_Options_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modal de fechar opções`)
};

/**
* | output |
* | --- |
* | "Close options modal" |
*
* @param {Close_Options_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_options_modal = /** @type {((inputs?: Close_Options_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Options_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_options_modal(inputs)
	if (locale === "de") return de_close_options_modal(inputs)
	if (locale === "it") return it_close_options_modal(inputs)
	if (locale === "ru") return ru_close_options_modal(inputs)
	if (locale === "es") return es_close_options_modal(inputs)
	if (locale === "zh-CN") return zh_cn2_close_options_modal(inputs)
	if (locale === "ja") return ja_close_options_modal(inputs)
	if (locale === "hi") return hi_close_options_modal(inputs)
	if (locale === "pt-PT") return pt_pt2_close_options_modal(inputs)
	return en_close_options_modal(inputs)
});